import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_DataFlow_BasicBlocks_Peephole = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Introduction to Data Flow Analysis -Basic Blocks - Optimization of Basic Blocks - Peephole Optimization"
    videos={[
      "https://www.youtube.com/embed/NK1D1hdV374",
      "https://www.youtube.com/embed/OKSlupcFGjc",
      "https://www.youtube.com/embed/id4p10d17KU",
    ]}
    takeaways={[]}
    questions={[
      `Consider the following code snippet: 

L1: LOAD R1, [R2] 
LOAD R3, [R4] 
MUL R1, R3 
ADD R1, R5 
STORE R1, [R6] 
JMP L1 

Perform peephole optimization on the given code snippet and provide the optimized version.`,

      `Consider the assembly code generated by a compiler. Apply peephole optimization to optimize the code. 

MOV R1, R2 
MOV R2, R1 

ADD R3, #0 
JMP L1 

MOV R4, #5 
6. L1: MUL R5, #1 
MOV R6, #0 
ADD R6, R7 
CMP R8, R9 

JNE L2 

JMP L3 

12. L2: JMP L3 

13. L3: NOP`,

      `Use the following code to identify the leader instructions and their corresponding basic blocks and draw the control flow graph. Write an algorithm to construct basic blocks and the control flow graph 

I)P := 0 
2)I := 1 
3)P := P+I 
4) IF P <= 60 GOTO (7) 
5)P := 0 
6)I := 5 
7) Tl := I*2 
8)I := T1+1 
9) IF I <= 20 GOTO (3) 
10)K := P*3`,

      `Given the following code snippet, identify the basic blocks, and construct a control flow graph (CFG). 

int globalvar; 

void process(int value) { 

int localvar; 

if (value < 0) { 

throw "Negative value error"; 

} else { 

for (int i = 0; i < value; i++) { 

if (i % 2 == 0) { 

globalvar += i; 

} else { 

localvar += i; 

print (globalvar); 

print(localvar); 

} 

int main() { 

try { 

process (5); 

} catch (const char* e) { 

print(e); 

} finally { 

print("Execution completed."); 

} 
}`,

      `Identify the basic blocks and construct a flow graph for the below prime number counting code from a large given array. Also, identify loops in the flow graph. 

for (i=2; i <= n; i++) 
a[i] = TRUE; 
count = 0; 
s = sqrt(n); 
for (i=2; i <= s; i++) 
if (a[i]) /* i has been found to be a prime */ 
{ 
count++; 
for (j=2*i; j <= n; j = j+i) 
a[j] = FALSE; /* no multiple of i is a prime */ 
}`
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_DataFlow_BasicBlocks_Peephole;
